import { useColors } from '@osmosis/react-ui/hooks/useColors';
import * as React from 'react';

/**
 * SkipBackward icon.
 */
function SkipBackward(
  props: React.SVGProps<SVGSVGElement> & { color?: string; size?: string },
) {
  const { color = 'text', size = '24px' } = props;
  const colors = useColors();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 423 478"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={1.41421}
      fill={colors[color] || color}
      {...props}
    >
      <path
        d="M1954.16 12307.9l20.28 20.3.73.7c7.71 8.8 8.17 22.7.69 31.7-8.49 10.1-25.66 10.8-35.36 1.5l-58.21-58.2c-.64-.7-.81-.8-1.41-1.6-7.15-8.5-7.33-22.1 0-30.8.6-.7.77-.9 1.41-1.6l58.06-58c2.32-2.2 2.83-2.5 4.07-3.3 4.13-2.6 9.03-3.8 13.95-3.7 11.63.7 21.86 10.4 22.86 21.9.61 6.9-2.11 14-6.94 19l-14.03 14.1h16.99c62.08.3 123.22 28.9 163.19 77.9 37.34 45.8 54.13 107.5 44.95 166.2-11.82 75.7-67.77 142.9-141.67 167.7-62.55 20.9-134.52 10.7-188.97-27.8-53.36-37.7-87.79-100.7-89.47-167.2-.05-1.8-.07-3.6-.07-5.4l.45-4.7c.46-1.5.76-3.1 1.36-4.5 4.19-10.2 15.84-16.6 26.83-14.4 9.27 1.8 17.03 9.5 18.89 18.8.53 2.6.45 5.3.5 7.9 1.28 62 40.55 122.1 99.32 147.2 32.18 13.7 68.8 16.7 102.87 8.3 49.74-12.1 92.85-49.1 112.43-97 17.33-42.3 15.71-92.1-4.47-133.3-25.79-52.7-80.64-89.9-142.07-91.7h-27.16zm77.31 94.6c15.47.1 30.44 6.7 39.58 20.5 15.6 23.5 14.35 56 9.1 78.7-3.31 14.4-10.55 28.7-23.73 36.5-21.28 12.5-52.18 6.3-65.71-14.8-15.76-24.5-13.98-58.6-7.99-81.1 3.47-13 10.49-25.8 22.45-33.1 7.81-4.8 17.14-6.7 26.3-6.7zm-112.46.7c8.57.3 15.86 7.4 15.9 16.7v94c5 0 9.97-.1 14.99 0 6.02.2 12.58 3.1 14.48 9.5 2.04 6.8-.26 14.9-7.12 18-2.49 1.1-5.25 1.5-7.97 1.5-20.71.1-41.42.1-62.13 0-6.19-.1-13.04-2.8-15.16-9.4-2.16-6.7-.08-15 7.02-18.1 2.55-1.1 5.35-1.5 8.14-1.5h14.2v-69.3l-9.99 6.1c-1.3.7-1.57.8-2.36 1.2-8.92 3.6-20.24-5.6-18.74-16.7.56-4.2 3.19-8 6.79-10.3 9.5-5.9 19.02-11.8 28.53-17.7 3.89-2.3 8.27-3.9 12.81-4h.61zm111.91 27.7c-3.52.1-7.07 1.1-9.73 3.5-6.3 5.7-7.24 15-8.08 22.8-1.81 16.9-2.6 35.2 4.08 49.6 2.39 5.2 7.21 9.3 13.73 9.3 3.54 0 7.14-.9 9.85-3.3 6.47-5.8 7.43-15.2 8.28-23.2 1.76-16.3 2.46-33.5-3.44-48.1-1.72-4.3-4.76-8.4-9.4-9.8-1.74-.6-3.16-.8-5.29-.8zm-167.63-226c11.34.7 21.3 9.8 22.75 20.8.95 7.3-1.69 14.8-6.83 20.1l-41.08 41.1 41.24 41.3.72.7c7.72 8.8 8.17 22.7.69 31.7-8.49 10.1-25.66 10.8-35.35 1.5l-58.21-58.2c-.65-.7-.82-.8-1.42-1.6-7.15-8.5-7.33-22.1 0-30.8.6-.7.77-.9 1.42-1.6l58.05-58c2.33-2.2 2.84-2.5 4.08-3.3 4.12-2.6 9.03-3.8 13.94-3.7z"
        fillRule="nonzero"
        transform="translate(-1765.21 -12204.9)"
      />
    </svg>
  );
}

export default SkipBackward;
